import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';
import { ARROW_POSITIONS, IArrow, IHole, ITutorialCard } from '@photosi/rn-components/tutorial/Tutorial.types';
import { brand } from 'src/theme/colors';

export const TUTORIAL_DEFAULT_VALUES = {
  tutorialVisible: false,
  targetArea: {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    borderRadius: 0,
  },
  tutorialCard: {
    illustration: ILLUSTRATION_NAMES.Exit2,
    text: '',
    ctaText: '',
    x: 0,
    y: 0,
    withDot: false,
  },
  arrow: {
    strokeColor: brand.main.water,
    strokeWidth: 3,
    arrowSize: 20,
    curvature: -0.8,
    startSide: ARROW_POSITIONS.LEFT,
    endSide: ARROW_POSITIONS.BOTTOM,
    startOffset: 30,
    endOffset: 30,
  },
  onPressNext: () => {},
  showTutorialDesktop: true,
};

export interface ShowTutorialParams {
  targetArea?: IHole;
  tutorialCard?: ITutorialCard;
  arrow?: IArrow;
  onPressNext?: () => void;
}
